import React from 'react';

import AiHandoffActionsShimmerComponent from './aiHandoffActionsShimmerComponent';
import ChatContainerShimmerComponent from './chatContainerShimmerComponent';
import ChatListBoxShimmerComponent from './chatListBoxShimmerComponent';
import ChatRoomTaskOwnerShimmerComponent from './chatRoomTaskOwnerShimmerComponent';
import DatePickerShimmerComponent from './datePickerShimmerComponent';
import LeadsFormShimmerComponent from './leadsFormShimmerComponent';
import LeadsShimmerComponent from './leadsShimmerComponent';
import OverviewAgendaShimmerComponent from './overviewAgendaShimmerComponent';
import OverviewUnReadMessagesShimmerComponent from './overviewUnReadMessagesShimmerComponent';
import OverviewVoiceMessagesShimmerComponent from './overviewVoiceMessagesShimmerComponent';
import ProfileAreaShimmerComponent from './profileAreaShimmerComponent';
import ClientChatContainerShimmerComponent from './clientChatContainerShimmerComponent';

import VIDABOO_CONSTANTS from '../../../../../config/consts';

const ShimmerWithEmptyImageComponent = ({
  showShimmer = true,
  shimmerComponentType = null,
}) => {
  return (
    <>
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES.OVERVIEW_AGENDA && (
        <OverviewAgendaShimmerComponent showShimmer={showShimmer} />
      )}
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES.OVERVIEW_VOICE_MESSAGES && (
        <OverviewVoiceMessagesShimmerComponent showShimmer={showShimmer} />
      )}
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES.OVERVIEW_UNREAD_MESSAGES && (
        <OverviewUnReadMessagesShimmerComponent showShimmer={showShimmer} />
      )}
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES.CHAT_CENTER_CHAT_LIST && (
        <ChatListBoxShimmerComponent showShimmer={showShimmer} />
      )}
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES
          .CHAT_CENTER_CHAT_CONTAINER && (
        <ChatContainerShimmerComponent showShimmer={showShimmer} />
      )}
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES.CLIENT_CHAT_CONTAINER && (
        <ClientChatContainerShimmerComponent />
      )}
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES
          .CHAT_CENTER_PROFILE_CONTAINER && <ProfileAreaShimmerComponent />}
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES.LEADS && (
        <LeadsShimmerComponent showShimmer={showShimmer} />
      )}
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES.LEADS_FORM && (
        <LeadsFormShimmerComponent />
      )}
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES.DATE_PICKER && (
        <DatePickerShimmerComponent />
      )}
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES.AI_HANDOFF_ACTIONS && (
        <AiHandoffActionsShimmerComponent />
      )}
      {shimmerComponentType ===
        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES.CHAT_ROOM_TASK_OWNER && (
        <ChatRoomTaskOwnerShimmerComponent />
      )}
    </>
  );
};

export default ShimmerWithEmptyImageComponent;
